import Footer from '@components/footer/footer.view';

export default Footer;
